<div class="progress-bar">
  <div class="progress-bar-value"></div>
</div>
